import { mapGetters } from 'vuex'

export const topComputed = {
    ...mapGetters(['topBuyLoaded', 'topSellLoaded', 'top1Buy', 'top3Buy', 'top1Sell', 'top3Sell'])
}
